import React from "react";
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Ferupen - Premium Barbershop & Grooming</title>
        <meta
          name="description"
          content="Ferupen - Το πιο κομψό barbershop στην Ελλάδα. Προϊόντα premium περιποίησης για τον σύγχρονο κύριο."
        />
      </Helmet>

      <div
        style={{
          padding: "40px 20px",
          maxWidth: "1200px",
          margin: "0 auto",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <h1
          style={{
            color: "#3E2723",
            marginBottom: "30px",
            fontSize: "2.5em",
            textAlign: "center",
          }}
        >
          Όροι και Προϋποθέσεις Χρήσης
        </h1>

        <section style={{ marginBottom: "30px" }}>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Καλώς ήρθατε στο Ferupen. Αυτοί οι Όροι και Προϋποθέσεις διέπουν τη
            χρήση του ιστότοπού μας και την αγορά προϊόντων από εμάς.
            Διαβάζοντας και χρησιμοποιώντας αυτόν τον ιστότοπο, συμφωνείτε να
            δεσμεύεστε από αυτούς τους όρους.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            1. Ορισμοί
          </h2>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>"Εμείς", "Μας", "Ferupen":</strong> Αναφέρεται στην
              εταιρεία Ferupen Barbershop με έδρα στην Οδό Αντωνόπουλος 38,
              Μαρκόπουλο Μεσογαίας, 51842, Ελλάδα
            </li>
            <li>
              <strong>"Εσείς", "Πελάτης", "Χρήστης":</strong> Το άτομο που
              χρησιμοποιεί τον ιστότοπο ή αγοράζει προϊόντα
            </li>
            <li>
              <strong>"Ιστότοπος":</strong> Το ferupen.com και όλες οι σχετικές
              σελίδες
            </li>
            <li>
              <strong>"Προϊόντα":</strong> Όλα τα είδη grooming και barbershop
              που διατίθενται προς πώληση
            </li>
            <li>
              <strong>"Υπηρεσίες":</strong> Οποιεσδήποτε υπηρεσίες που
              παρέχονται μέσω του ιστότοπου
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            2. Αποδοχή Όρων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Χρησιμοποιώντας τον ιστότοπό μας, επιβεβαιώνετε ότι:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              Είστε τουλάχιστον 18 ετών ή χρησιμοποιείτε τον ιστότοπο υπό την
              επίβλεψη γονέα/κηδεμόνα
            </li>
            <li>Έχετε τη νομική ικανότητα να συνάψετε δεσμευτική σύμβαση</li>
            <li>Θα χρησιμοποιήσετε τον ιστότοπο μόνο για νόμιμους σκοπούς</li>
            <li>Θα τηρήσετε όλους τους τοπικούς νόμους και κανονισμούς</li>
            <li>Όλες οι πληροφορίες που παρέχετε είναι ακριβείς και πλήρεις</li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            3. Προϊόντα και Υπηρεσίες
          </h2>
          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            3.1 Περιγραφές Προϊόντων
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Καταβάλλουμε κάθε δυνατή προσπάθεια να εμφανίζουμε με ακρίβεια τα
            χρώματα και τις εικόνες των προϊόντων μας. Ωστόσο, δεν μπορούμε να
            εγγυηθούμε ότι η οθόνη του υπολογιστή σας εμφανίζει τα χρώματα με
            ακρίβεια. Διατηρούμε το δικαίωμα να περιορίσουμε τις ποσότητες και
            να διακόψουμε οποιοδήποτε προϊόν χωρίς προηγούμενη ειδοποίηση.
          </p>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            3.2 Τιμές
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Όλες οι τιμές εμφανίζονται σε Ευρώ (€) και περιλαμβάνουν ΦΠΑ, εκτός
            εάν αναφέρεται διαφορετικά. Οι τιμές υπόκεινται σε αλλαγή χωρίς
            προηγούμενη ειδοποίηση.
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              Τα έξοδα αποστολής υπολογίζονται κατά την ολοκλήρωση της
              παραγγελίας
            </li>
            <li>
              Προσφορές και εκπτώσεις μπορούν να εφαρμοστούν με κωδικούς
              προώθησης
            </li>
            <li>
              Διατηρούμε το δικαίωμα να διορθώνουμε τυπογραφικά λάθη στις τιμές
            </li>
          </ul>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            3.3 Διαθεσιμότητα
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Όλες οι παραγγελίες υπόκεινται σε διαθεσιμότητα. Θα σας ενημερώσουμε
            το συντομότερο δυνατό εάν ένα προϊόν δεν είναι διαθέσιμο ή εάν
            αναμένεται καθυστέρηση. Θα έχετε την επιλογή να αναμένετε ή να
            ακυρώσετε την παραγγελία σας.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            4. Παραγγελίες και Πληρωμές
          </h2>
          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            4.1 Διαδικασία Παραγγελίας
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Για να ολοκληρώσετε μια παραγγελία:
          </p>
          <ol
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Προσθέστε προϊόντα στο καλάθι αγορών</li>
            <li>Ελέγξτε το καλάθι και προχωρήστε στο checkout</li>
            <li>Παράσχετε στοιχεία αποστολής και τιμολόγησης</li>
            <li>Επιλέξτε μέθοδο πληρωμής</li>
            <li>Ελέγξτε και επιβεβαιώστε την παραγγελία σας</li>
          </ol>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            4.2 Επιβεβαίωση Παραγγελίας
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Μετά την υποβολή της παραγγελίας σας, θα λάβετε ένα email
            επιβεβαίωσης στη διεύθυνση που παρέχετε. Αυτό το email δεν συνιστά
            αποδοχή της παραγγελίας σας. Η σύμβαση μεταξύ μας θεωρείται
            ολοκληρωμένη όταν αποστείλουμε τα προϊόντα.
          </p>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            4.3 Μέθοδοι Πληρωμής
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Αποδεχόμαστε τις ακόλουθες μεθόδους πληρωμής:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              Πιστωτικές/Χρεωστικές κάρτες (Visa, Mastercard, American Express)
            </li>
            <li>PayPal</li>
            <li>Τραπεζική μεταφορά</li>
            <li>Αντικαταβολή (όπου διατίθεται, με επιπλέον χρέωση)</li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Όλες οι πληρωμές επεξεργάζονται με ασφάλεια μέσω κρυπτογραφημένων
            συνδέσεων. Δεν αποθηκεύουμε πλήρη στοιχεία πιστωτικών καρτών στους
            διακομιστές μας.
          </p>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            4.4 Ακύρωση Παραγγελίας
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Μπορείτε να ακυρώσετε την παραγγελία σας μέχρι την ολοκλήρωση της
            επεξεργασίας. Επικοινωνήστε μαζί μας αμέσως στο{" "}
            <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a> ή στο
            +302299022996. Εάν η παραγγελία έχει ήδη αποσταλεί, ισχύει η
            πολιτική επιστροφών μας.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            5. Αποστολή και Παράδοση
          </h2>
          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            5.1 Χρόνοι Παράδοσης
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Οι χρόνοι παράδοσης εξαρτώνται από την τοποθεσία:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>Αττική:</strong> 1-3 εργάσιμες ημέρες
            </li>
            <li>
              <strong>Υπόλοιπη Ελλάδα:</strong> 2-5 εργάσιμες ημέρες
            </li>
            <li>
              <strong>Νησιά:</strong> 3-7 εργάσιμες ημέρες
            </li>
            <li>
              <strong>Διεθνείς αποστολές:</strong> 5-15 εργάσιμες ημέρες
            </li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Οι χρόνοι παράδοσης είναι ενδεικτικοί και δεν αποτελούν εγγύηση. Δεν
            ευθυνόμαστε για καθυστερήσεις που οφείλονται σε απρόβλεπτες συνθήκες
            ή μεταφορικές εταιρείες.
          </p>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            5.2 Έξοδα Αποστολής
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Τα έξοδα αποστολής υπολογίζονται με βάση το βάρος και την τοποθεσία
            παράδοσης:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Δωρεάν αποστολή για παραγγελίες άνω των €50 στην Ελλάδα</li>
            <li>Σταθερή χρέωση €4.90 για παραγγελίες κάτω των €50</li>
            <li>Ειδικές τιμές για νησιά και απομακρυσμένες περιοχές</li>
          </ul>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            5.3 Παραλαβή
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Κατά την παραλαβή, παρακαλούμε ελέγξτε τη συσκευασία για ζημιές. Εάν
            το δέμα φαίνεται ελαττωματικό, σημειώστε το στο δελτίο παραλαβής
            πριν υπογράψετε και επικοινωνήστε μαζί μας εντός 24 ωρών.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            6. Επιστροφές και Επιστροφές Χρημάτων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Για λεπτομερείς πληροφορίες, ανατρέξτε στην
            <strong> Πολιτική Επιστροφών και Επιστροφής Χρημάτων</strong> μας.
            Συνοπτικά:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Δικαίωμα υπαναχώρησης εντός 14 ημερών από την παραλαβή</li>
            <li>
              Τα προϊόντα πρέπει να επιστραφούν στην αρχική τους κατάσταση
            </li>
            <li>Πλήρης επιστροφή χρημάτων για ελαττωματικά προϊόντα</li>
            <li>
              Δεν γίνονται δεκτές επιστροφές προϊόντων που έχουν ανοιχτεί (για
              λόγους υγιεινής)
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            7. Εγγύηση και Ευθύνη
          </h2>
          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            7.1 Εγγύηση Προϊόντων
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Όλα τα προϊόντα μας καλύπτονται από τη νόμιμη εγγύηση σύμφωνα με την
            ελληνική νομοθεσία. Εγγυόμαστε ότι τα προϊόντα είναι γνήσια,
            καινούργια και χωρίς ελαττώματα κατασκευής.
          </p>

          <h3
            style={{
              color: "#5D4037",
              marginBottom: "10px",
              fontSize: "1.3em",
            }}
          >
            7.2 Περιορισμός Ευθύνης
          </h3>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Στο μέγιστο βαθμό που επιτρέπεται από το νόμο:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Δεν ευθυνόμαστε για έμμεσες ή συνεπακόλουθες ζημιές</li>
            <li>
              Η συνολική ευθύνη μας περιορίζεται στην αξία της παραγγελίας σας
            </li>
            <li>
              Δεν ευθυνόμαστε για αλλεργικές αντιδράσεις ή ακατάλληλη χρήση
              προϊόντων
            </li>
            <li>Συνιστούμε να διαβάζετε πάντα τις οδηγίες χρήσης</li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            8. Πνευματική Ιδιοκτησία
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Όλο το περιεχόμενο του ιστότοπου, συμπεριλαμβανομένων:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Κειμένων, γραφικών, λογοτύπων, εικόνων</li>
            <li>Βίντεο, ήχου, κώδικα</li>
            <li>Εμπορικών σημάτων και σχεδιασμού</li>
            <li>Συλλογών δεδομένων</li>
          </ul>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Είναι ιδιοκτησία της Ferupen και προστατεύεται από τους νόμους
            πνευματικής ιδιοκτησίας. Απαγορεύεται η αναπαραγωγή, διανομή ή
            τροποποίηση χωρίς γραπτή άδεια.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            9. Συμπεριφορά Χρήστη
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Συμφωνείτε να ΜΗΝ:
          </p>
          <ul
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>Χρησιμοποιείτε τον ιστότοπο για παράνομους σκοπούς</li>
            <li>Παραβιάζετε νόμους ή κανονισμούς</li>
            <li>Παρενοχλείτε ή βλάπτετε άλλους χρήστες</li>
            <li>Μεταδίδετε ιούς ή κακόβουλο κώδικα</li>
            <li>Συλλέγετε δεδομένα χωρίς άδεια</li>
            <li>Παρεμποδίζετε τη λειτουργία του ιστότοπου</li>
            <li>Δημιουργείτε ψευδείς λογαριασμούς</li>
          </ul>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            10. Προστασία Δεδομένων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Η συλλογή και επεξεργασία των προσωπικών σας δεδομένων διέπεται από
            την
            <strong> Πολιτική Απορρήτου</strong> μας, η οποία συμμορφώνεται με
            τον GDPR και την ελληνική νομοθεσία προστασίας δεδομένων.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            11. Τροποποιήσεις Όρων
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτούς τους όρους ανά πάσα
            στιγμή. Οι τροποποιήσεις τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή
            τους στον ιστότοπο. Η συνεχιζόμενη χρήση του ιστότοπου μετά τις
            αλλαγές συνιστά αποδοχή των νέων όρων.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            12. Διακοπή Υπηρεσιών
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Διατηρούμε το δικαίωμα να αναστείλουμε ή να τερματίσουμε την
            πρόσβαση σας στον ιστότοπο ή τις υπηρεσίες μας χωρίς προηγούμενη
            ειδοποίηση, για οποιονδήποτε λόγο, συμπεριλαμβανομένης της
            παραβίασης αυτών των όρων.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            13. Ανωτέρα Βία
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Δεν ευθυνόμαστε για την αδυναμία εκτέλεσης οποιασδήποτε υποχρέωσης
            λόγω γεγονότων πέραν του εύλογου ελέγχου μας, όπως φυσικές
            καταστροφές, πόλεμος, τρομοκρατία, απεργίες, κυβερνητικές ενέργειες
            ή τεχνικές βλάβες.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            14. Διαχωρισιμότητα
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Εάν οποιαδήποτε διάταξη αυτών των όρων κριθεί άκυρη ή μη εφαρμόσιμη,
            οι υπόλοιπες διατάξεις θα παραμείνουν σε πλήρη ισχύ.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            15. Εφαρμοστέο Δίκαιο
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "20px" }}>
            Αυτοί οι Όροι διέπονται και ερμηνεύονται σύμφωνα με τους νόμους της
            Ελλάδας. Οποιαδήποτε διαφορά που προκύπτει θα επιλύεται από τα
            αρμόδια δικαστήρια της Ελλάδας.
          </p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            16. Επίλυση Διαφορών
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Σε περίπτωση διαφωνίας:
          </p>
          <ol
            style={{
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "20px",
              marginLeft: "20px",
            }}
          >
            <li>
              Επικοινωνήστε μαζί μας πρώτα στο{" "}
              <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
            </li>
            <li>
              Θα προσπαθήσουμε να επιλύσουμε το ζήτημα φιλικά εντός 30 ημερών
            </li>
            <li>
              Εάν δεν επιτευχθεί λύση, μπορείτε να προσφύγετε στο Ευρωπαϊκό
              Κέντρο Καταναλωτή
            </li>
            <li>
              Τελευταίο μέσο είναι η νομική οδός μέσω των ελληνικών δικαστηρίων
            </li>
          </ol>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2
            style={{
              color: "#3E2723",
              marginBottom: "15px",
              fontSize: "1.8em",
            }}
          >
            17. Επικοινωνία
          </h2>
          <p style={{ lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
            Για ερωτήσεις σχετικά με αυτούς τους Όρους και Προϋποθέσεις:
          </p>
          <div
            style={{
              backgroundColor: "#F5F5F5",
              padding: "20px",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Ferupen Barbershop</strong>
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Οδός Αντωνόπουλος 38
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Μαρκόπουλο Μεσογαίας, 51842
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              Ελλάδα
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Email:</strong>{" "}
              <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Τηλέφωνο:</strong> +302299022996
            </p>
            <p style={{ lineHeight: "1.8", color: "#555", margin: "5px 0" }}>
              <strong>Ωράριο Εξυπηρέτησης:</strong> Δευτέρα-Παρασκευή
              09:00-18:00
            </p>
          </div>
        </section>

        <section
          style={{
            marginBottom: "30px",
            paddingTop: "20px",
            borderTop: "2px solid #3E2723",
          }}
        >
          <p
            style={{
              lineHeight: "1.8",
              color: "#555",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            <strong>Τελευταία Ενημέρωση:</strong> Ιανουάριος 2025
          </p>
          <p
            style={{
              lineHeight: "1.8",
              color: "#555",
              textAlign: "center",
              marginTop: "15px",
            }}
          >
            Χρησιμοποιώντας τον ιστότοπο Ferupen, αποδέχεστε αυτούς τους Όρους
            και Προϋποθέσεις πλήρως.
          </p>
        </section>
      </div>
    </>
  );
};

export default TermsConditions;
